import { DfdError, ErrorAction, ErrorLevelKeys } from './types';

export const SET_DFD_ERROR = 'GLOBAL.SET_DFD_ERROR' as const;
export const DISMISS_ERROR = 'GLOBAL.DISMISS_ERROR' as const;

export function handleError(
  error: DfdError,
  level: ErrorLevelKeys,
  callback?: () => void
): ErrorAction {
  error.id = error.id || Date.now();
  error.level = level;
  if (callback) {
    error.callback = callback;
  }
  return {
    type: SET_DFD_ERROR,
    error
  };
}

export function dismissError(id: string): ErrorAction {
  return {
    type: DISMISS_ERROR,
    id
  };
}
